import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditDeleteActColComponent } from './components/edit-delete-act-col.component';
import { CoreModule } from '../../../core/core.module';


@NgModule({
  imports: [
    CommonModule,
    CoreModule
  ],
  exports: [
    EditDeleteActColComponent
  ],
  providers: [
  ],
  entryComponents: [EditDeleteActColComponent],
  declarations: [EditDeleteActColComponent]
})
export class CommonActionColumnModule { }
